// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"Z4-z","dimensionLabel":"_4-z","styleChooserControlWrapper":"a5-z","styleChooserControl":"b5-z","disabled":"c5-z","giftCard":"d5-z","styleChooserText":"e5-z"};